import { makeStyles, Theme } from '@material-ui/core/styles'
import { createStyles } from '@material-ui/core'

// @ts-ignore
export const useNonProfitCardStyles = makeStyles((theme: Theme) =>
  createStyles({
    bold: {
      fontWeight: 'bold',
    },
    imgHolder: {
      height: '60px',
      flex: '0 0 60px',
      borderRadius: '50%',
      backgroundColor: theme.palette.grey[100],
      overflow: 'hidden',
      position: 'relative',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      boxSizing: 'border-box',
    },
    imgHolderWithBackground: {
      backgroundImage: 'var(--nonprofit-image-url)',
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat',
    },
    noImageIcon: {
      color: theme.palette.grey[500],
      fontSize: 32,
    },
    loader: {
      position: 'absolute',
      zIndex: 1,
    },
    link: {
      color: 'inherit',
      textDecoration: 'none',
    },
    nonprofitName: {
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },
    cardContent: {
      height: '10em',
    },
    cardText: {
      marginLeft: 10,
      display: 'flex',
      flexDirection: 'column',
      width: '77%',
    },
    cardCategoryLine: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'start',
      marginBottom: 5,
    },
    cardName: {
      fontSize: 16,
      marginBottom: 5,
      lineHeight: 1,
      color: theme.palette.grey[900],
    },
    cardCategory: {
      fontSize: 11,
      marginBottom: 4 /* Really 6px but Typeography adds 2px marginBottom */,
    },
    multilineEllipsis: {
      display: '-webkit-box',
      WebkitLineClamp: 3,
      WebkitBoxOrient: 'vertical',
      overflow: 'hidden',
    },
    cardCategoryLabel: {
      color: theme.palette.grey[700],
      letterSpacing: theme.spacing(0.1),
    },
    cardCategoryName: {
      color: theme.palette.text.primary,
      fontWeight: 500,
    },
    space: {
      marginLeft: 2,
    },
    noDescription: {
      lineHeight: 1.5,
      fontSize: 12,
      color: theme.palette.grey[700],
      fontWeight: 500,
    },
    italicText: {
      fontStyle: 'italic',
      color: theme.palette.grey[500],
    },
  })
)
